<template>
  <div class="b2b-loading">
    <div class="spinner">
      <span v-for="n in 8" :key="n"></span>
    </div>
    <img
      class="loading-image"
      src="@/assets/tbeasy-loading.svg"
      alt="TBEasy loading"
    >
  </div>
</template>

<script>
export default {
  name: 'b2b-app-loading',
};
</script>

<style scoped lang="scss">
.b2b-loading {
  position: fixed;
  inset: 0;
  z-index: 9999;
}

.spinner {
  position: absolute;
  top: 48vh;
  left: 58.3vw;
  width: 48px;
  height: 48px;
  transform: translate(-50%, -50%);

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    margin: -5px;
    border-radius: 50%;
    transform-origin: 0 0;
    animation:
      orbit 1.2s linear infinite,
      colorShift 1.2s linear infinite;

    @for $i from 1 through 8 {
      &:nth-child(#{$i}) {
        animation-delay: -#{1.2s / 8 * ($i - 1)}, -#{1.2s / 8 * ($i - 1)};
      }
    }
  }
}

.loading-image {
  position: absolute;
  top: calc(17vh + 110px);
  left: 48vw;
  width: min(26.0417vw, 500px);
  transform: translateX(-50%);
}

@keyframes orbit {
  from { transform: rotate(0deg) translateX(20px); }
  to   { transform: rotate(360deg) translateX(20px); }
}

@keyframes colorShift {
  0%   { background: $easyColorPrimary; }
  25%  { background: $easyColorPrimary; }
  50%  { background: $easyColorSecondary; }
  75%  { background: $easyColorSecondary; }
  100% { background: $easyColorSecondary; }
}

@media (max-width: 1300px) {
  .spinner {
    width: 38px;
    height: 38px;
    left: 58.5vw;
  }

  .spinner span {
    width: 13px !important;
    height: 13px !important;
  }

  .loading-image {
    top: calc(10vh + 110px);
    left: 48vw;
  }
}

@media (max-width: 1050px) {
  .spinner {
    width: 32px;
    height: 32px;
    top: 47.5vh;
    left: 74.5vw;
  }

  .spinner span {
    width: 10px !important;
    height: 10px !important;
  }

  .loading-image {
    width: min(61.0417vw, 500px);
    top: calc(27vh + 110px);
    left: 50vw;
  }
}

@media (max-height: 745px) {
  .loading-image {
    top: calc(24vh + 110px);
  }
}

@media (max-height: 670px) {
  .loading-image {
    top: calc(20vh + 110px);
  }
}

@media (width: 1024px) and (height: 1366px) {
  .spinner {
    width: 34px;
    height: 34px;
    top: 42.5vh;
    left: 69.6vw;
  }

  .spinner span {
    width: 17px !important;
    height: 17px !important;
  }

  .loading-image {
    width: min(54vw, 500px);
    top: calc(21vh + 110px);
    left: 50vw;
  }
}

@media (width: 820px) and (height: 1180px) {
  .spinner {
    width: 34px;
    height: 34px;
    top: 43.5vh;
    left: 71.5vw;
  }

  .spinner span {
    width: 17px !important;
    height: 17px !important;
  }

  .loading-image {
    width: min(54vw, 500px);
    top: calc(21vh + 110px);
    left: 50vw;
  }
}

@media (width: 768px) and (height: 1024px) {
  .spinner {
    width: 30px;
    height: 30px;
    top: 47vh;
    left: 73vw;
  }

  .spinner span {
    width: 15px !important;
    height: 15px !important;
  }

  .loading-image {
    width: min(58vw, 500px);
    top: calc(20vh + 110px);
    left: 50vw;
  }
}
</style>
